import { useQuery } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services/relabelCases";
import { queryKeys } from "src/constants";

const useRelabelCaseStats = (relabelCaseService: RelabelCaseService) => {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.relabelCaseStats(),
    queryFn: () => relabelCaseService.getRelabelCaseStats()
  });

  return {
    pendingCount: data?.pendingScanIn ?? 0,
    inRelabellingCount: data?.inRelabelling ?? 0,
    completeCount: data?.complete ?? 0,
    isLoading
  };
};

export { useRelabelCaseStats };
